import Component from './Component'

export default class Date extends Component {

	static _type = 'Date'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('input')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Extend select
		$(this.input_el).datepicker(Object.assign({
			autoclose: true,
			clearBtn: true,
			language: 'hu',
			weekStart: 1,
			orientation: 'bottom',
			format: 'yyyy. mm. dd.'
		}, ('params' in this.params) ? this.params.params : { }))

		// Create bound event handlers and register them
		this.inputListener = Date._inputListener.bind(this)
		this.updateListener = Date._updateListener.bind(this)
		$(this.input_el).on('change', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		// Initial state
		let value = this.form.data[this.params.name]
		$(this.input_el).val(value ? Anvil.moment(value).format('YYYY. MM. DD.') : '')
		$(this.input_el).datepicker('update')
	}

	static _inputListener () {
		let val = $(this.input_el).val()
		let date = val ? Anvil.moment(val, 'YYYY. MM. DD.').format('YYYY-MM-DD') : null

		// Send data to the record
		this.form.data[this.params.name] = date
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		if ($(this.input_el).val() != value) {
			$(this.input_el).val(value)
		}

		// Refresh extension
		$(this.input_el).val(value ? Anvil.moment(value).format('YYYY. MM. DD.') : '')
		$(this.input_el).datepicker('update')

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {

		if (errors == null) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_el).off('change', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		// Destroy extension
		$(this.input_el).datepicker('destroy')

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
